const liveSearch = {
  client_id: true,
  time_from: true,
  status: true,
  plugin_count: true,
  plugin_launched: true,
  request_id: true,
};

export {liveSearch}